// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a3bc88ce","239":"679ee039","453":"e12d337c","455":"71e232a5"}[chunkId] + ".chunk.js";
};